import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';
export const pageNotificationSclice = createSlice({
  name: 'pageNotification',
  initialState: {
    notification: null,
    recordingProgress: {},
    recordingAndArchivedNotifications: []
  },
  reducers: {
    setNotification: (state, action) => {
      state.notification = action.payload;
    },
    setRecordingProgressNotification: (state, action) => {
      state.recordingProgress = action.payload
    },
    setRecordingAndArchivedNotifications: (state, action) => {
      let notificationList = state.recordingAndArchivedNotifications;
      let existNoti = _.find(notificationList, n => n.videoTaskId == action.payload.videoTaskId && n.status == action.payload.status)
      if (!existNoti) {
        notificationList.push({
          videoTaskId: action.payload.videoTaskId,
          status: action.payload.status,
          videoType: action.payload.videoType,
          date: Date.now()
        })
        state.recordingAndArchivedNotifications = notificationList;
      }
    }
  }
});

export const pageNotiActions = pageNotificationSclice.actions;
export const pageNotiState = (state) => state.pageNotification;
export default pageNotificationSclice.reducer;
